<div class="profile-box info-box flex flex-col">
  <header class="accent">
    <div class="title" i18n>Изменение Email</div>
  </header>

  <div class="content">
    <form (ngSubmit)="onSubmitChangeEmailForm()" [formGroup]="changeEmailForm" novalidate class="flex flex-col">
      <mat-form-field>
        <input type="text" matInput i18n-placeholder placeholder="Новый Email" formControlName="newEmail" autofocus />
      </mat-form-field>

      <button
        mat-raised-button
        type="submit"
        color="accent"
        [disabled]="!changeEmailForm.valid || submitting"
        class="mx-16"
        i18n
        >ИЗМЕНИТЬ</button
      >
    </form>
  </div>
</div>
